import { render, staticRenderFns } from "./YS.vue?vue&type=template&id=2ca9b996&scoped=true&"
import script from "./YS.vue?vue&type=script&lang=js&"
export * from "./YS.vue?vue&type=script&lang=js&"
import style0 from "./YS.vue?vue&type=style&index=0&id=2ca9b996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9b996",
  null
  
)

export default component.exports